let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tZiF")).then(() => parcelRequire('jqi1P'));